<div class="table-wrapper pdb-30">
  <table>
    <thead>
      <tr>
        <td class="no-border"><br></td>
        <th scope="col" rowspan="2" class="header bold centered border-bold-left border-bold-right" translate>m1.sprint8.cockpit-kontrolle.modellvarianten.drr.col-head</th>
      </tr>
      <tr>
        <td class="header border-bold-left"><br></td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="border-bold-left text-align-left" translate>m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.regression-output.table.rowheader.geschlechtskoeffizient</td>
        <td class="border-bold-left border-bold-right text-align-right">{{data?.geschlechtskoeffizient | numberFormat: crtLocale:3 | replaceNullOrUndefinedTo: 'NA'}}</td>
      </tr>
      <tr>
        <td class="border-bold-left text-align-left" translate>m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.regression-output.table.rowheader.standardfehler</td>
        <td class="border-bold-left border-bold-right text-align-right">{{data?.standardfehler | numberFormat: crtLocale:3 | replaceNullOrUndefinedTo: 'NA'}}</td>
      </tr>
      <tr>
        <td class="border-bold-left text-align-left" [innerHTML]="'m1.sprint8.cockpit-kontrolle.einfluss-extremwerte.drr.rowheader.teststatistik' | translate"></td>
        <td class="border-bold-left border-bold-right text-align-right">{{data?.zWert | numberFormat: crtLocale:3 | replaceNullOrUndefinedTo: 'NA'}}</td>
      </tr>
      <tr>
        <td class="border-bold-left text-align-left" translate>Pr(>|<span style="font-style: italic;">z</span>|)</td>
        <td class="border-bold-left border-bold-right text-align-right">
          {{ data?.prZ | numberFormat: crtLocale:4 | replaceNullOrUndefinedTo: 'NA'}}
        </td>
      </tr>
      <tr>
        <td class="border-bold-left text-align-left" translate>m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.regression-output.table.rowheader.sigDiff0</td>
        <td class="border-bold-left border-bold-right text-align-right">{{data?.sig0 | boolToYesNo | replaceNullOrUndefinedTo: 'NA'}}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td class="hint" colspan="2" translate>m1.sprint8.cockpit-kontrolle.modellvarianten.drr.footer-hint</td>
      </tr>
    </tfoot>
  </table>
</div>
